export default function SSMPSIPage() {
const files = [
  "Decizie comisie SSM_PSI.PDF",
  "Decizie responsabil SSM_PSI.PDF",
  "Plan de masuri de norme PSI.PDF",
  "Planificare exercitii de evacuare_PSI.PDF",
  "PO evacuarii in caz de incendii.PDF",
  "PO prevenire stingere incendii.PDF",
  "Reguli de masuri de prevenire_incendii.PDF",
  "Tematica si grafic anual de instruire_PSI.PDF",
];

  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">

        <div className="space-y-2">
          {files.map((file) => (
            <p key={file}>
              <a
                href={`/documente/SSM_PSI/${file}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                {file}
              </a>
            </p>
          ))}
        </div>

      </main>
    </div>
  );
}